import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { Trans } from 'react-i18next';

export function ProfessionalContract() {
  return (
    <Stack gap="10px">
      <Typography fontWeight="medium">
        <Trans
          components={[]}
          i18nKey="loanFormPage.agreements.form.fields.professionalContract.title"
        />
      </Typography>
      <Trans
        components={[]}
        i18nKey="loanFormPage.agreements.form.fields.professionalContract.content"
      />
    </Stack>
  );
}
